var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.93746 3.84687V2.58017C9.93746 2.24422 9.80321 1.92204 9.56425 1.68448C9.3253 1.44693 9.0012 1.31348 8.66326 1.31348H2.54714C2.2092 1.31348 1.88511 1.44693 1.64615 1.68448C1.40719 1.92204 1.27295 2.24422 1.27295 2.58017V10.1804C1.27295 10.5163 1.40719 10.8385 1.64615 11.076C1.88511 11.3136 2.2092 11.4471 2.54714 11.4471H8.66326C9.0012 11.4471 9.3253 11.3136 9.56425 11.076C9.80321 10.8385 9.93746 10.5163 9.93746 10.1804V8.91366M11.9762 3.84687L14.5245 6.38026M14.5245 6.38026L11.9762 8.91366M14.5245 6.38026H5.82819",
    stroke: "#F9FCFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.ad0d4158622bcb414080e13bdf5fc538.svg";
export { ForwardRef as ReactComponent };